<template>
  <a-row >
    <a-row v-if="linkList.length > 0" class="content-border" :key="linkrefresh">
      <a-col :span="24" style="padding: 8px">
        <a-tag v-for="(link, index) in linkList" :key="index" closable @close="deleteCardLink(link.id, index)">
          <a :href="'http://' + server + '/card/' + link.agent_key + '/' + link.id + '.html'" target="_blank">{{link.title}}</a>
        </a-tag>
      </a-col>
    </a-row>
    <a-row >
      <a-row style="margin-top: 8px; text-align: left;">
        <a-col :span="12" >
          <span style="font-weight: 600; color: black;"><a-divider type="vertical" />我的名片</span>
        </a-col>
      </a-row>
      <a-row class="card-setting">
        <a-col :span="24" class="name-card" :style="cardStyle">
            <a-row style="margin-top: 5%; height: 40%; margin-left: 7%; margin-right: 7%;font-weight: 600;">
              <a-row :style="textSize">
                <a-col :span="12" style="text-align: left">
                  <a-col :style="textXL">
                    <span v-if="user.fullname" style="color: #333230;">{{user.fullname}}</span>
                  </a-col>
                  <a-col>
                    <span v-if="user.affiliation" style="color: #3D3C3A;">{{user.job}}</span>
                  </a-col>
                  <a-col>
                    <span v-if="user.affiliation" style="color: #666666;">{{user.affiliation}}</span>
                  </a-col>
                </a-col>
                <a-col :span="12" style="text-align: right;">
                    <a-avatar v-if="user.img_profile_url" :size="iconSize" :src="user.img_profile_url" alt="avatar"/>
                    <a-avatar v-else :size="iconSize" icon="user"/>
                </a-col>
              </a-row>
            </a-row>
            <a-row style="margin-top: 10%; height: 30%;margin-bottom: 3%; margin-right: 7%; font-weight: 600; color: black;text-align: right;">
              <a-row :style="textSize">
                <a-col>
                  <span v-if="user.phone" style="color: #6F6E6C; margin-right: 10px">{{user.phone}}</span>
                  <a-icon type="phone" style="color: rgba(0,0,0,0.25);"/>
                </a-col>
                <a-col>
                  <span v-if="user.email" style="color: #6F6E6C;margin-right: 10px">{{user.email}}</span>
                  <a-icon type="mail" style="color: rgba(0,0,0,0.25);"/>
                </a-col>
                <a-col>
                  <span v-if="user.address" style="color: #6F6E6C;margin-right: 10px">{{user.address}}</span>
                  <a-icon type="environment" style="color: rgba(0,0,0,0.25);"/>
                </a-col>
              </a-row>
            </a-row>
        </a-col>
      </a-row>
      <a-row v-if="fileList.length > 0" style="text-align: left; margin-top: 24px;">
        <a-col :span="24" >
          <span style="font-weight: 600; color: black;"><a-divider type="vertical" />产品介绍</span>
        </a-col >
      </a-row>
      <a-row :key="refresh">
        <a-row v-if="fileList.length > 0" v-for="(item, index) in fileList" :key="index" style="margin-top:8px">
              <a-col :span="24">
                <a-checkbox 
                  @change="handleCheckbox(item.id)"
                  :autoFocus="true" 
                  style="position: absolute; top: 10px; right: 10px;"
                />
                <img :src="BACKEND_API_PREFIX + item.img" alt="avatar" style="width: 100%; border: 1px solid #d1d5da;border-bottom: 1px solid #e6f7ff; border-top-right-radius: 5px;border-top-left-radius: 5px;"/>
              </a-col>
              <a-col :span="24" class="product-content" style="padding:8px;text-align: left;">
                  <span  style="word-break: break-all;">{{item.content}}</span>
              </a-col>
        </a-row>
      </a-row>

    </a-row>
  </a-row >
</template>

<script>
import BasicPage from "@/layout/BasicPage.vue";
import { SearchPanel } from "@/com/Basic";

import { BACKEND_API_PREFIX, SHARE_LINK_HOST} from '@/util/config';

export default {
  name: "sellerprofile",
  props: {
    filelist: {
      type: Array,
      default: function() {
        return {}
      }
    },
    linklist: {
      type: Array,
      default: function() {
        return {}
      }
    },
  },
  data() {
    return {
      refresh: 500,
      linkrefresh: 1,
      server: SHARE_LINK_HOST,
      BACKEND_API_PREFIX: BACKEND_API_PREFIX,
      fileList: this.filelist,
      linkList: this.linklist,
      selectedList: [],
      user:{},
      cardStyle: {
        'width': "100%",
        'height': "550px",
        },
      textSize: {
        'fontSize': "30px"
        },
      textXL: {
        'fontSize': "50px"
        },
      iconSize: 250, 
    };
  },
  watch: {
    filelist: function(newvalue, oldvalue) {
      this.fileList = newvalue;
    },
    linklist: function(newvalue, oldvalue) {
      this.linkList = newvalue;
    },
  },
  components: {
    BasicPage,
    SearchPanel,
  },
  methods: {
    deleteCardLink(id, index) {
      let postdata = {
        task: "DELETE_CARD_LINK",
        id: id
      };
      let that = this;
      that.post('ads-card', postdata)
        .then(function(data) {
          if (data.ret == 200) {
            let list = [];
            for(let i = 0; i < that.linkList.length; i++) {
              if (i != index) {
                list.push(that.linkList[i]);
              }
            }
            console.log(list)
            that.linkList = list;
            that.$emit('emitlinklist', that.linkList);
            that.$message.success("删除成功！");
            that.linkrefresh += 1;
          } else {
            that.$message.error("删除失败！");
          }
        }).catch(function (e) {
          console.log(e)
          that.$message.error("删除失败！");
      });
    },
    handleCheckbox (value) {
      if(this.selectedList.length < 1){
        this.selectedList.push(value);
        this.$emit('selectedlist', this.selectedList);
        return
      }
      else{
        let list = this.selectedList;
        let newList = [];
        let newValue = true;
        for (let i = 0; i < list.length; i++) {
          if(list[i] == value){
            newValue = false;
            continue
          }
        }
        if(newValue == true){
          this.selectedList.push(value);
        }
        else{
            for (let i = 0; i < list.length; i++){
              if(list[i] != value){
                newList.push(list[i]);
              }
            }
            this.selectedList = newList;
        }
        this.$emit('selectedlist', this.selectedList);
      }
    },
  },
  created() {
    let deviceWidth = document.body.clientWidth
    if(deviceWidth > 1200){
      deviceWidth = 1200
    }
    let card_height = deviceWidth * (5/9)
    this.cardStyle['height']= card_height + "px";

    if (deviceWidth <= 500) {
      this.textXL['fontSize']= "25px";
      this.textSize['fontSize']= "16px";
      this.iconSize= 100;
    }
    if (deviceWidth > 500 && deviceWidth <= 768) {
      this.textXL['fontSize']= "35px";
      this.textSize['fontSize']= "20px";
      this.iconSize= 150;
    }
    let postdata = {
      'task':'GET_USER_INFO',
      'id':this.$store.getters.getId()
    };
    let that = this;
    that.post('user', postdata)
    .then(function(data){
      if(data.ret ==200){
        that.user=data.data;
        }
      }).catch(function(e){
        console.log(e);
      });
  },
}
</script>

<style scoped>
  /deep/.ant-menu-horizontal {
    border: 0;
    border-bottom: 1px solid #d1d5da;
    -webkit-box-shadow: none;
    box-shadow: none;
    line-height: 38px;
    background-color: #f5f6f5 /*#f1f8ff*/;
    text-align: left;
    white-space: nowrap;
  }
  .card-setting {
    margin: 8px 0px;
  }
  .content-border {
    margin-top: 8px;
    color: gray;
    text-align: left;
    border: 1px solid #d1d5da;
  }
  .name-card {
    background-image: url('../../assets/img/name-card.png');
    background-size: 100% 100%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    border-radius: 5px;
    border: none;
  }
  .product-content {
    border: 0;
    border-bottom: 1px solid #d1d5da;
    border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .ant-divider, .ant-divider-vertical {
    margin: 0 8px 0 0px;
    display: inline-block;
    font-weight: 600; color: black;
    height: 0.9em;
    width: 1px;
    vertical-align: middle;
    position: relative;
    top: -0.06em;
  }
</style>

